import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import URLstateContext from "../../../provider/CommonContext";
import "./FandOTodaysMarket.css";
import { Rings } from 'react-loader-spinner';


function FandOTodaysMarket() {
  const [data, setData] = useState([]);
  const [chartdata, setchartData] = useState([]);
  const [chartperiod, setchartperiod] = useState([]);
  const [ExpDateDrop, setExpDateDrop] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  const [valuebtn, setValueBtn] = useState('nifty');
  const [defaultValue, setDefaultValue] = useState('selectValue');
  let getData, getchartData, indicator, expDate, finalExpDate, selectedValue;

  useEffect(() => {
    if(chartperiod != ''){
    const getUrlchart = BaseURL + "FandOChart";
    fetch(`${getUrlchart}/futIDX/${valuebtn}/${chartperiod}/0/XX`)
      .then((response) => response.json())
      .then((data) => {
        getchartData = data.data;
        setchartData(getchartData);
        // console.log("chartdata:"+JSON.stringify(getchartData));
      })
      .catch((error) => {
        // console.log("not found the api");
      });
    }
  }, [valuebtn, chartperiod]);


  useLayoutEffect(() => {
    let root = am5.Root.new("chartdivFandO");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(am5xy.XYChart.new(root, {
      panY: false,

      layout: root.verticalLayout
    }));

    indicator = root.container.children.push(am5.Container.new(root, {
      width: am5.p100,
      height: am5.p100,
      layer: 1000,
      background: am5.Rectangle.new(root, {
        fill: am5.color(0xffffff),
        fillOpacity: 0.7
      })
    }));

    indicator.children.push(am5.Label.new(root, {
      text: "Loading...",
      fontSize: 25,
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: am5.p50
    }));


    chart.get("colors").set("colors", [
      am5.color(0x024FA1),

    ]);

    // Create Y-axis
    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      maxDeviation: 1,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));

    // Create X-Axis

    let baseI = { timeUnit: "minute", count: 1 };

    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      rotation: -60,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15
    });
    let xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
      //groupData: true,
      maxDeviation: 0.5,
      renderer: xRenderer,
      baseInterval: baseI,

    }));

    // xAxis.get("dateFormats")["day"] = "MM/dd";
    // xAxis.get("periodChangeDateFormats")["day"] = "MMMM";

    // Generate random data
    function generateChartData() {

      let chartData = [];

      // current date
      //let firstDate = new Date();
      // now set 500 minutes back
      //firstDate.setMinutes(firstDate.getDate() - 500, 0, 0);

      // and generate 500 data items
      //console.log("chart period:"+chartperiod);
      // console.log("chartdata",JSON.stringify(chartdata));



      if (chartdata != null && chartdata != []) {
        for (var i = 0; i < chartdata.length; i++) {
          let newDate = new Date(chartdata[i].UpdTime);

          chartData.push({
            time: newDate.getTime(),
            price: chartdata[i].LTP
          });
        }
      }
      else {

      }
      return chartData;


    }

    // console.log("ddddd:"+JSON.stringify(generateChartData()));
    let data = generateChartData();



    //let lbltxt = "[bold]{name}[/]\n{valueX.formatDate()}: {valueY}";

    let lbltxt = "[bold] ₹ {valueY} | {valueX.formatDate('HH:mm')}";

    // Create series
    let series = chart.series.push(am5xy.LineSeries.new(root, {
      name: "Series",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "price",
      valueXField: "time",
      tooltip: am5.Tooltip.new(root, {
        pointerOrientation: "horizontal",
        labelText: lbltxt
      })
    }));

    series.strokes.template.set("strokeWidth", 2);
    series.fills.template.setAll({
      visible: true,
      fillOpacity: 0.4
    });
    if (chartperiod === "1D" || chartperiod === "5D") {
      series.bullets.push(function (root) {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 3,
            fill: series.get("fill"),
            fill: am5.color(0x024FA1),
          })
        });
      });
    }

    series.set("fill", am5.color(0x80D962)); // set Series color to red



    series.data.setAll(data);



    series.fills.template.set("fillGradient", am5.LinearGradient.new(root, {
      stops: [{
        opacity: 0
      }, {
        opacity: 1
      }],
      rotation: 90
    }));

    // Add cursor
    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none",
      xAxis: xAxis
    }));

    xAxis.set("tooltip", am5.Tooltip.new(root, {}));

    yAxis.set("tooltip", am5.Tooltip.new(root, {}));
    indicator.hide();

    return () => {
      root.dispose();
    };
  }, [chartdata]);


  useEffect(() => {

    if (valuebtn === "nifty") {
      const getUrl = BaseURL + "FandOExpDateandSymbol";
      fetch(`${getUrl}/fut/${valuebtn}`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
         // console.log("data:", getData);
          expDate = getData[0].ExpiryDateText;
          finalExpDate = expDate.split(' ').join('-');
          setExpDateDrop(expDate.split(' ').join('-'));
          setTimeout(() => {
            selectedValue = document.getElementById('select_value').value;
            const getUrlchart = BaseURL + "FandOChart";
            fetch(`${getUrlchart}/futIDX/nifty/${selectedValue}/0/XX`)
              .then((response) => response.json())
              .then((data) => {
                getchartData = data.data;
                setchartData(getchartData);
                // console.log("chartdata:"+JSON.stringify(getchartData));
              })
              .catch((error) => {
                // console.log("not found the api");
              });
          }, 100)
        })
        .catch((error) => {
          // console.log("not found the api");
        });
    } else {
      const getUrl = BaseURL + "FandOExpDateandSymbol";
      fetch(`${getUrl}/fut/${valuebtn}`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
          // console.log("data:", getData);
          expDate = getData[0].ExpiryDateText;
          finalExpDate = expDate.split(' ').join('-');
          setExpDateDrop(expDate.split(' ').join('-'));
          selectedValue = document.getElementById('select_value').value;
          const getUrlchart = BaseURL + "FandOChart";
          fetch(`${getUrlchart}/futIDX/banknifty/${selectedValue}/0/XX`)
            .then((response) => response.json())
            .then((data) => {
              getchartData = data.data;
              setchartData(getchartData);
              // console.log("chartdata:"+JSON.stringify(getchartData));
            })
            .catch((error) => {
              // console.log("not found the api");
            });
        })
        .catch((error) => {
          // console.log("not found the api");
        });
    }
  }, [valuebtn]);

  return (
    <>
      <div className='fandO-header'>
        <h4>Today's Market</h4>
      </div>
      <section className="company-chart-section">
        <Container className="table-box">
          <Row>
            <Col md={12}>
              <div className='fandO-toggle'>
                <button value="nifty" className={(valuebtn === "nifty") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>NIFTY</button>
                <button value="banknifty" className={(valuebtn === "banknifty") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>BANK NIFTY</button>
              </div>
              <div className='fandO-select'>
                {/* aria-label="Select Expiry Date" */}
                <select aria-label="Select Expiry Date" id="select_value" onChange={(event) => { setchartperiod(event.target.value) }}>
                  <option value="-">Select Expiry Date</option>
                  {data && data.map(({ ExpiryDateText, ExpDate }) => (
                    <option value={ExpDate.split('T')[0]} selected={ExpDateDrop === ExpiryDateText.split(' ').join('-')}>{ExpiryDateText.split(' ').join('-')}</option>
                  )
                  )}
                </select>
              </div>
              {(chartdata === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> :''}
              <div id="chartdivFandO" style={{ width: "100%", height: "325px" }}></div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default FandOTodaysMarket;